import qs from 'qs'
import axios from 'axios'
import Vue from 'vue'
import whiteList from './whiteList'

// 创建自定义接口服务实例
const service = axios.create({
  baseURL: Vue.prototype.$dm.get(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformRequest: [function (data) {
    return qs.stringify(data)
  }]
})

// 响应中间件
service.interceptors.response.use(response => {
  if (response.data.code) {
    response.data.code = parseInt(response.data.code)
  }
  switch (response.data.code) {
    case 3002:
      // 未登录
      if(whiteList.some(route => window.$app.$route.path === route)) {
        return response.data;
      } else {
        let url = encodeURIComponent(location.href)
        location.href = Vue.prototype.$dm.get('m') + '/user/login?redirect=' + url
        return Promise.reject('')
      }
    case 2000:
      // 正常
      return response.data
    default:
      // 业务错误
      return Promise.reject(response.data.msg)
  }
}, () => {
  Vue.prototype.$toast('网络异常，请稍后再试')
  return Promise.reject('')
})

// 接口测试用
window.$http = service

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js